// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tpF1","colBig":"styles_colBig__OeRsT","colSmall":"styles_colSmall__2Wwh7","shopifyNameWrapper":"styles_shopifyNameWrapper__3JOb_"};